import React, { useEffect, useState } from 'react';
import { ChevronLeft, X, ArrowRight } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
interface DeveloperDetailsPageProps {
  developerId: number;
  developerName: string;
  onBack: () => void;
  onAccreditationSubmit?: () => void;
  showAccreditationModal?: boolean;
}
export function DeveloperDetailsPage({
  developerId,
  developerName,
  onBack,
  onAccreditationSubmit,
  showAccreditationModal: initialShowModal = false
}: DeveloperDetailsPageProps) {
  const [showAccreditationModal, setShowAccreditationModal] = useState(initialShowModal);
  const [accreditationMessage, setAccreditationMessage] = useState('We are Xbeng brokerages and would like to Reprint your project.\nThanks.');
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Map developer names to their logos
  const getDeveloperLogo = (name: string) => {
    const logoMap: Record<string, string> = {
      'Mountain View': 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
      'Palm Hills': 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
      'Hyde Park': 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
      'Emaar Misr': 'https://cdn.magicpatterns.com/uploads/wijYmcxqmndw1XGyexVnGN/Emaar-Misr-Logo.png',
      Sodic: 'https://cdn.magicpatterns.com/uploads/m7ECvP64WQu5Q5fDGkVyT2/OIP.heFoNUDluvlfTF84mNzC8AHaB6.webp',
      'Ora Developers': 'https://cdn.magicpatterns.com/uploads/qiVDQQJwbWPnXu1qEPHnnJ/1655298523997.jpg',
      'Tatweer Misr': 'https://cdn.magicpatterns.com/uploads/vFd4y3e6VTvKmbjouHn6Df/OIP.WU0po8LB04ePZzUToFmyKQHaD2.webp',
      Inertia: 'https://cdn.magicpatterns.com/uploads/gtoHa4YFoGm69rL7tSXhd6/OIP.8_yr1_3JwTWhYPh-6mszrAHaBG.webp'
    };
    return logoMap[name] || 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png';
  };
  // Mock developer data
  const developer = {
    id: developerId,
    name: developerName,
    description: 'About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View',
    logo: getDeveloperLogo(developerName),
    type: 'Real Estate Developer',
    featuredProject: {
      name: 'Madinety',
      commission: '2.5%',
      incentive: '1%',
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop'
    },
    commissionIncentives: {
      commission: '2%',
      incentive: '1%'
    },
    offers: {
      plan: '10 Years Plan',
      downpayment: 'Downpayment 0%',
      installments: 'Equal Instalments'
    },
    projects: [{
      id: 1,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop'
    }, {
      id: 2,
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop'
    }, {
      id: 3,
      image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=400&h=300&fit=crop'
    }, {
      id: 4,
      image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&h=300&fit=crop'
    }, {
      id: 5,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop'
    }, {
      id: 6,
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop'
    }]
  };
  const handleProceedConnect = () => {
    if (onAccreditationSubmit) {
      onAccreditationSubmit();
    }
    setShowAccreditationModal(false);
    setAccreditationMessage('We are Xbeng brokerages and would like to Reprint your project.\nThanks.');
  };
  return <div className="min-h-screen bg-gradient-to-br from-purple-200 via-blue-100 to-purple-100 pb-20 font-sans w-full" data-id="element-1409">
      <div className="w-full mx-auto min-h-screen relative" data-id="element-1410">
        {/* Header */}
        <div className="bg-transparent px-4 py-4 safe-top flex items-center justify-between sticky top-0 z-10" data-id="element-1411">
          <button onClick={onBack} className="p-2 -ml-2 text-primary hover:bg-white/20 rounded-full transition-colors" data-id="element-1412">
            <ChevronLeft className="w-6 h-6" data-id="element-1413" />
          </button>
          <div className="flex-1" data-id="element-1414"></div>
        </div>

        <div className="px-4 space-y-6 pb-4" data-id="element-1415">
          {/* Developer Header */}
          <div className="flex items-center justify-between" data-id="element-1416">
            <div className="flex items-center gap-3" data-id="element-1417">
              <div className="w-12 h-12 rounded-full bg-white border-2 border-accent overflow-hidden flex items-center justify-center p-2" data-id="element-1418">
                <img src={developer.logo} alt={developer.name} className="w-full h-full object-contain" data-id="element-1419" />
              </div>
              <div data-id="element-1420">
                <h1 className="text-lg font-bold text-primary" data-id="element-1421">
                  {developer.name}
                </h1>
              </div>
            </div>
            <button onClick={() => setShowAccreditationModal(true)} className="bg-accent hover:bg-accent-dark text-primary font-semibold px-6 py-2 rounded-lg transition-colors text-sm" data-id="element-1422">
              Connect Developer
            </button>
          </div>

          {/* Featured Project Card */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-1423">
            <div className="relative h-56" data-id="element-1424">
              <img src={developer.featuredProject.image} alt={developer.featuredProject.name} className="w-full h-full object-cover" data-id="element-1425" />
              <div className="absolute bottom-4 left-4" data-id="element-1426">
                <h2 className="text-3xl font-bold text-white mb-1" data-id="element-1427">
                  {developer.featuredProject.name}
                </h2>
                <p className="text-white text-sm" data-id="element-1428">
                  {developer.featuredProject.commission} +{' '}
                  {developer.featuredProject.incentive} Incentive
                </p>
              </div>
            </div>

            <div className="p-4" data-id="element-1429">
              <button className="w-full border-2 border-secondary text-secondary font-semibold py-3 rounded-lg hover:bg-secondary hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-1430">
                Share Project
                <ArrowRight className="w-4 h-4" data-id="element-1431" />
              </button>
            </div>
          </div>

          {/* Commission and Incentives */}
          <div data-id="element-1432">
            <h3 className="text-lg font-bold text-primary mb-3" data-id="element-1433">
              Commission and Incentives
            </h3>
            <div className="flex gap-3" data-id="element-1434">
              <div className="bg-white/60 backdrop-blur-sm border-2 border-secondary text-secondary font-semibold px-6 py-2 rounded-full text-sm" data-id="element-1435">
                {developer.commissionIncentives.commission} commission
              </div>
              <div className="bg-white/60 backdrop-blur-sm border-2 border-secondary text-secondary font-semibold px-6 py-2 rounded-full text-sm" data-id="element-1436">
                {developer.commissionIncentives.incentive} Incentive
              </div>
            </div>
          </div>

          {/* Offers */}
          <div data-id="element-1437">
            <h3 className="text-lg font-bold text-primary mb-3" data-id="element-1438">Offers %</h3>
            <div className="bg-secondary text-white rounded-2xl p-6" data-id="element-1439">
              <p className="text-lg font-semibold mb-1" data-id="element-1440">
                {developer.offers.plan}
              </p>
              <p className="text-sm opacity-90 mb-1" data-id="element-1441">
                {developer.offers.downpayment}
              </p>
              <p className="text-sm opacity-90" data-id="element-1442">
                {developer.offers.installments}
              </p>
            </div>
          </div>
        </div>

        {/* Accreditation Request Modal */}
        {showAccreditationModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-end justify-center" data-id="element-1443">
            <div className="bg-white w-full max-w-md rounded-t-3xl pb-8" data-id="element-1444">
              <div className="px-6 pt-8 pb-6" data-id="element-1445">
                <h2 className="text-2xl font-bold text-neutral-text mb-6" data-id="element-1446">
                  Accredited Request
                </h2>

                {/* Developer Info */}
                <div className="flex items-center gap-3 mb-6" data-id="element-1447">
                  <div className="w-14 h-14 rounded-full bg-white border-2 border-accent overflow-hidden flex items-center justify-center p-2" data-id="element-1448">
                    <img src={developer.logo} alt={developer.name} className="w-full h-full object-contain" data-id="element-1449" />
                  </div>
                  <div data-id="element-1450">
                    <h3 className="font-bold text-neutral-text text-lg" data-id="element-1451">
                      {developer.name}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-1452">{developer.type}</p>
                  </div>
                </div>

                {/* Message Input */}
                <div className="mb-6" data-id="element-1453">
                  <textarea value={accreditationMessage} onChange={e => setAccreditationMessage(e.target.value)} placeholder="We are Xbeng brokerages and would like to Reprint your project.&#10;Thanks." rows={6} className="w-full px-4 py-4 border-2 border-secondary rounded-2xl focus:ring-2 focus:ring-secondary focus:border-secondary resize-none text-sm text-gray-600" data-id="element-1454" />
                </div>

                {/* Proceed Button */}
                <button onClick={handleProceedConnect} className="w-full bg-primary hover:bg-primary-dark text-white font-semibold py-4 rounded-xl transition-colors text-base" data-id="element-1455">
                  Proceed Connect
                </button>
              </div>
            </div>
          </div>}

        <BottomNav data-id="element-1456" />
      </div>
    </div>;
}